import { AxiosResponse } from "axios"

export const downloadFile = async (response: AxiosResponse<Blob>) => {
  const a = document.createElement('a')
  a.href = URL.createObjectURL(response.data)
  a.download = response.headers['content-disposition']!.split('filename=')[1]!.replace(/"/g, '')
  a.click()
}
